import { render } from "./ComplianceToday.vue?vue&type=template&id=2dc52c62"
import script from "./ComplianceToday.vue?vue&type=script&lang=js"
export * from "./ComplianceToday.vue?vue&type=script&lang=js"

import "./ComplianceToday.vue?vue&type=style&index=0&id=2dc52c62&lang=css"

import exportComponent from "C:\\Users\\Miftah Faridl\\Documents\\KIM-APPS\\motul-power-web-report\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__